import { render, staticRenderFns } from "./FacebookMessengerWizard.vue?vue&type=template&id=2f014452&"
import script from "./FacebookMessengerWizard.vue?vue&type=script&lang=js&"
export * from "./FacebookMessengerWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports